"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
export class CampaignItemComponent extends STCComponentMixin(LitElement) {
  render() {
    const indexLinkAriaLabel = this.indexLinkAriaLabel || this.title.toLowerCase();
    const newLinkAriaLabel = this.newLinkAriaLabel || `Add new ${this.title.toLowerCase()}`;
    return html`
      <div class="campaignsLandingPageTileItem mbl">
        <h2 class="campaignsLandingPageTileItemHeading mbs">
          <hi-link class="campaignsLandingPageTileItemHeadingLink" href="${this.indexLink}" aria-label="${indexLinkAriaLabel}"> ${this.title}</hi-link>
        </h2>
        <p class="text-sz-l">${this.desc}</p>
        <hi-button class="campaignsLandingPageTileItemAddBtn mtm" aesthetic="link" href="${this.newLink}" aria-label="${newLinkAriaLabel}">
          <hi-icon kind="plus" theme="primary" mode="presentation"></hi-icon>
          <span>Add New</span>
        </hi-button>
      </div>
    `;
  }
}
__decorateClass([
  property({ type: String, attribute: "index-link" })
], CampaignItemComponent.prototype, "indexLink", 2);
__decorateClass([
  property({ type: String, attribute: "index-link-aria-label" })
], CampaignItemComponent.prototype, "indexLinkAriaLabel", 2);
__decorateClass([
  property({ type: String, attribute: "title" })
], CampaignItemComponent.prototype, "title", 2);
__decorateClass([
  property({ type: String, attribute: "desc" })
], CampaignItemComponent.prototype, "desc", 2);
__decorateClass([
  property({ type: String, attribute: "new-link" })
], CampaignItemComponent.prototype, "newLink", 2);
__decorateClass([
  property({ type: String, attribute: "new-link-aria-label" })
], CampaignItemComponent.prototype, "newLinkAriaLabel", 2);
customElements.define("stc-campaign-item", CampaignItemComponent);
